<p-floatlabel variant="on">
  <p-datepicker [formControl]="control()" [invalid]="control().invalid && control().touched" [timeOnly]="true"
                appendTo="body" fluid/>
  <label for="time_picker">{{ label() }}
    @if (isRequired()) {
      <span class="text-red-500">*</span>
    }</label>
</p-floatlabel>
@if (control().invalid && control().touched) {
  @if (control().hasError('required')) {
    <p-message severity="error" size="small" variant="simple">{{ 'error.required' | translate }}</p-message>
  }
}
